__turbopack_context__.v({
  "className": "myfont_1b3478dc-module___6D7zW__className",
});
